<template>
  <section
    class="list"
    v-infinite-scroll="fetchNextPage"
    infinite-scroll-disabled="isBusy"
    infinite-scroll-distance="10"
  >
    <div class="row">
      <div
        v-for="course in courses"
        :key="course.id"
        class="col-lg-4 col-md-6 mb-4"
      >
        <slot v-if="$scopedSlots.default" v-bind:course="course" />
        <CourseThumbBox v-else :course="course" />
      </div>
    </div>
  </section>
</template>

<script>
  import infiniteScroll from 'vue-infinite-scroll'
  import CourseThumbBox from '@/components/course/CourseThumbBox'

  export default {
    components: {
      CourseThumbBox,
    },

    directives: { infiniteScroll },

    props: {
      courses: { type: Array, required: true },
      isBusy: { type: Boolean, required: true  }
    },

    methods: {
      async fetchNextPage () {
          this.$emit('next')
      }
    }
  }
</script>